import { render, staticRenderFns } from "./productsSet.vue?vue&type=template&id=5f608a0e&scoped=true&"
import script from "./productsSet.vue?vue&type=script&lang=js&"
export * from "./productsSet.vue?vue&type=script&lang=js&"
import style0 from "./productsSet.vue?vue&type=style&index=0&id=5f608a0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f608a0e",
  null
  
)

export default component.exports